import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".error-library--rWv8D {\n  color: #ed002f;\n}\n\n.noborder-library--1DCPX {\n  border-bottom: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n}";
var styles = {"noborder":"noborder-library--1DCPX"};
styleInject(css_248z);

export { styles as default };
